/* Dilo — scripts de la page produit */
(function () {
  'use strict';

  /* ---------- Galerie produit ---------- */
  if (!customElements.get('dilo-gallery')) {
    customElements.define('dilo-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dl-gallery__track');
        this.slides = [...this.querySelectorAll('.dl-gallery__slide')];
        this.thumbs = [...this.querySelectorAll('.dl-gallery__thumb')];
        this.dots = [...this.querySelectorAll('.dl-gallery__dot')];
        this.index = 0;
        this.querySelectorAll('.dl-gallery__arrow').forEach((b) =>
          b.addEventListener('click', () => this.go(this.index + Number(b.dataset.dir), true))
        );
        this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i, true)));
        let raf;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const w = this.track.clientWidth;
            if (!w) return;
            const i = Math.round(this.track.scrollLeft / w);
            if (i !== this.index) { this.index = i; this.sync(); }
          });
        }, { passive: true });
        this.sync();
      }
      go(i, smooth) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        const w = this.track.clientWidth;
        this.track.scrollTo({ left: this.index * w, behavior: smooth ? 'smooth' : 'auto' });
        this.sync();
      }
      sync() {
        this.thumbs.forEach((t, k) => {
          t.classList.toggle('is-active', k === this.index);
          if (k === this.index) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        this.dots.forEach((d, k) => d.classList.toggle('is-active', k === this.index));
        const strip = this.querySelector('.dl-gallery__thumbs');
        const active = this.thumbs[this.index];
        if (strip && active && strip.scrollWidth > strip.clientWidth) {
          const item = active.parentElement;
          strip.scrollTo({ left: item.offsetLeft - strip.clientWidth / 2 + item.clientWidth / 2, behavior: 'smooth' });
        }
      }
    });
  }

  /* ---------- Carrousel générique ---------- */
  if (!customElements.get('dilo-slider')) {
    customElements.define('dilo-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dl-sl__track');
        this.slides = [...this.querySelectorAll('.dl-sl__slide')];
        this.dotsWrap = this.querySelector('.dl-sl__dots');
        this.prev = this.querySelector('.dl-sl__arrow--prev');
        this.next = this.querySelector('.dl-sl__arrow--next');
        this.querySelectorAll('.dl-sl__arrow').forEach((b) =>
          b.addEventListener('click', () => this.step(Number(b.dataset.dir)))
        );
        this.track.addEventListener('scroll', () => requestAnimationFrame(() => this.sync()), { passive: true });
        window.addEventListener('resize', () => this.build());
        this.build();
      }
      perView() { return window.matchMedia('(min-width: 750px)').matches ? 3 : 1; }
      pages() { return Math.max(1, this.slides.length - this.perView() + 1); }
      build() {
        this.dotsWrap.innerHTML = '';
        for (let i = 0; i < this.pages(); i++) {
          const d = document.createElement('button');
          d.type = 'button'; d.className = 'dl-sl__dot'; d.setAttribute('aria-label', 'Diapositive ' + (i + 1));
          d.addEventListener('click', () => this.goto(i));
          this.dotsWrap.appendChild(d);
        }
        this.sync();
      }
      goto(i) {
        const s = this.slides[i]; if (!s) return;
        const mobile = !window.matchMedia('(min-width: 750px)').matches;
        const left = mobile ? s.offsetLeft - (this.track.clientWidth - s.clientWidth) / 2 : s.offsetLeft - this.track.offsetLeft;
        this.track.scrollTo({ left: mobile ? left : s.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
      }
      step(dir) { this.goto(Math.max(0, Math.min(this.pages() - 1, this.cur() + dir))); }
      cur() {
        const first = this.slides[0].offsetLeft;
        const mobile = !window.matchMedia('(min-width: 750px)').matches;
        let best = 0, bd = Infinity;
        this.slides.forEach((s, i) => {
          const pos = mobile ? (s.offsetLeft + s.clientWidth / 2) - (this.track.scrollLeft + this.track.clientWidth / 2) : (s.offsetLeft - first) - this.track.scrollLeft;
          if (Math.abs(pos) < bd) { bd = Math.abs(pos); best = i; }
        });
        return Math.min(best, this.pages() - 1);
      }
      sync() {
        const c = this.cur();
        [...this.dotsWrap.children].forEach((d, i) => d.classList.toggle('is-active', i === c));
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.hidden = this.track.scrollLeft < 2;
        if (this.next) this.next.hidden = this.track.scrollLeft >= max;
      }
    });
  }

  /* ---------- Minuteur de l'offre ---------- */
  function startTimers(scope) {
    scope.querySelectorAll('.dilo-offer-timer').forEach((timer) => {
      if (timer.dataset.started === 'true') return;
      timer.dataset.started = 'true';
      const duration = (parseInt(timer.dataset.durationMinutes, 10) || 15) * 60 * 1000;
      const storageKey = timer.dataset.storageKey || 'dilo-offer-timer';
      const display = timer.querySelector('[data-countdown]');
      const row = timer.querySelector('[data-countdown-row]');
      const finished = timer.querySelector('[data-finished]');
      let endTime, interval;
      try {
        /* chaque nouvelle visite repart de la durée complète ; une visite en cours garde son compte à rebours */
        const saved = Number(sessionStorage.getItem(storageKey));
        if (saved > Date.now()) endTime = saved; else { endTime = Date.now() + duration; sessionStorage.setItem(storageKey, String(endTime)); }
      } catch (e) { endTime = Date.now() + duration; }
      function update() {
        const left = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
        display.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
        if (left === 0) { row.hidden = true; finished.hidden = false; clearInterval(interval); }
      }
      update();
      if (endTime > Date.now()) interval = setInterval(update, 1000);
    });
  }

  /* ---------- Barre d'achat collante ---------- */
  function initSticky() {
    const bar = document.querySelector('.sticky-atc');
    const atc = document.querySelector('.main-product-atc');
    if (!bar || !atc) return;
    const show = (v) => { bar.classList.toggle('is-visible', v); bar.setAttribute('aria-hidden', v ? 'false' : 'true'); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => show(!e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(atc);
    }
    bar.querySelector('.sticky-atc__scroll-btn')?.addEventListener('click', (ev) => {
      const t = document.getElementById(ev.currentTarget.dataset.target);
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Minuteur du panier ---------- */
  function cartTimer() {
    const KEY = 'dilo-cart-reserve';
    const tick = () => {
      document.querySelectorAll('[data-cart-timer]').forEach((el) => {
        let end = Number(sessionStorage.getItem(KEY)) || 0;
        if (!end || end < Date.now() - 60000) { end = Date.now() + 10 * 60 * 1000; sessionStorage.setItem(KEY, String(end)); }
        const left = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        el.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
      });
    };
    try { tick(); setInterval(tick, 1000); } catch (e) {}
  }

  document.addEventListener('DOMContentLoaded', () => { startTimers(document); initSticky(); cartTimer(); });
  document.addEventListener('shopify:section:load', (e) => { startTimers(e.target); initSticky(); });
})();
